<template>
	<v-app>
		<app-loader />
		<app-modal />
		<app-toolbar />
		<app-nav-drawer />
		<v-content>
			<router-view />
		</v-content>
		<app-footer />
	</v-app>
</template>

<script>
import AppLoader from './app/views/App.Loader'
import AppModal from './app/views/App.Modal'
import AppToolbar from './app/views/App.Toolbar'
import AppNavDrawer from './app/views/App.NavDrawer'
import AppFooter from './app/views/App.Footer'

export default {
	name: 'App',
	components: {
		AppLoader,
		AppModal,
		AppToolbar,
		AppNavDrawer,
		AppFooter
	},
	data() {
		return {
			//
		}
	}
}
</script>
